export const getUserFullName = (data: any): string => {
    if (!data?.lastName || !data?.firstName || !data?.surName) {
        return "Профіль не заповнено";
    }

    return `${data.lastName} ${data.firstName} ${data.surName}`;
};
